import { FTLBidsI } from '@/core/interfaces/ftl_bids.interface'
import { FTLBidsService } from '../services/ftl_bids.service'
import {
    EnterCarrierDataParamsT,
    EnterCostPriceParamsT,
    EnterCostToBePaidParamsT,
    FTLBidGetResponseT,
    FTLBidsGetListParamsT,
    FTLBidsGetListResponseT,
    ChangeStatusParamsT,
    EnterCommentParamsT,
    FTLBidsGetExcelParamsT,
    FtlGetListParams,
    FtlIntracityGetListResponse,
    EnterCarrierDataIntracityParams,
    FtlIntracityGetQuantityParams,
    FtlIntracityGetQuantityResponse,
    FtlGetListParamsCamel,
    FtlOrderSendRequestForPaymentPayload,
} from '../types/ftl_bids.types'
import {
    CompleteIntracityPayload,
    EnterDeliveredDataIntracityPayload,
    StatusToCompletedPayload,
} from '@/core/types/additional_services.types'
import { FTLOrderDownloadResponseT } from '@/core/types/couriers.types'

const ftlBidsService = new FTLBidsService()

class OrdersRealisation implements FTLBidsI {
    getList(params: FTLBidsGetListParamsT): Promise<FTLBidsGetListResponseT> {
        return ftlBidsService.getList(params)
    }

    getFtlList(params: FtlGetListParamsCamel): Promise<FtlIntracityGetListResponse> {
        return ftlBidsService.getFtlList(params)
    }

    getListIntracity(params: FtlGetListParams): Promise<FtlIntracityGetListResponse> {
        return ftlBidsService.getListIntracity(params)
    }

    getFTLBid(id: number): Promise<FTLBidGetResponseT> {
        return ftlBidsService.getFTLBid(id)
    }

    updateFTLBid(id: number, form_data: FormData): Promise<void> {
        return ftlBidsService.updateFTLBid(id, form_data)
    }

    enterCostPrice(params: EnterCostPriceParamsT): Promise<void> {
        return ftlBidsService.enterCostPrice(params)
    }

    enterCostToBePaid(params: EnterCostToBePaidParamsT): Promise<void> {
        return ftlBidsService.enterCostToBePaid(params)
    }

    enterComment(id: number, params: EnterCommentParamsT): Promise<void> {
        return ftlBidsService.enterComment(id, params)
    }

    enterCarrierData(params: EnterCarrierDataParamsT): Promise<void> {
        return ftlBidsService.enterCarrierData(params)
    }

    enterCarrierDataIntracity(params: EnterCarrierDataIntracityParams): Promise<void> {
        return ftlBidsService.enterCarrierDataIntracity(params)
    }

    enterDeliveryData(id: number, params: FormData): Promise<void> {
        return ftlBidsService.enterDeliveryData(id, params)
    }

    enterDeliveryDataIntracity(
        id: number,
        params: EnterDeliveredDataIntracityPayload
    ): Promise<void> {
        return ftlBidsService.enterDeliveryDataIntracity(id, params)
    }

    enterCompletedData(id: number, payload?: StatusToCompletedPayload): Promise<void> {
        return ftlBidsService.enterCompletedData(id, payload)
    }

    completeIntracity(id: number, payload?: CompleteIntracityPayload): Promise<void> {
        return ftlBidsService.completeIntracity(id, payload)
    }

    changeStatus(params: ChangeStatusParamsT): Promise<void> {
        return ftlBidsService.changeStatus(params)
    }

    changeStatusFTLOrder(id: number, payload: FormData): Promise<void> {
        return ftlBidsService.changeStatusFTLOrder(id, payload)
    }

    exportDeclaration(id: number, payload: FormData): Promise<void> {
        return ftlBidsService.exportDeclaration(id, payload)
    }

    crossBorder(id: number, payload: FormData): Promise<void> {
        return ftlBidsService.crossBorder(id, payload)
    }

    sendD24(id: number): Promise<void> {
        return ftlBidsService.sendD24(id)
    }

    createFtl(courier_payload: FormData): Promise<void> {
        return ftlBidsService.createFtl(courier_payload)
    }

    resendOneC(id: number): Promise<void> {
        return ftlBidsService.resendOneC(id)
    }

    exportExcel(id: number): Promise<FTLOrderDownloadResponseT> {
        return ftlBidsService.exportExcel(id)
    }

    uploadCustomPaymentDocument(file: File): Promise<{ data: { path: string } }> {
        return ftlBidsService.uploadCustomPaymentDocument(file)
    }

    exportBids(params: FTLBidsGetExcelParamsT): Promise<Blob> {
        return ftlBidsService.exportBids(params)
    }

    exportFtlIntracity(params: FtlGetListParams): Promise<Blob> {
        return ftlBidsService.exportFtlIntracity(params)
    }

    exportAccountantFtlIntracity(params: FtlGetListParams): Promise<Blob> {
        return ftlBidsService.exportAccountantFtlIntracity(params)
    }

    printFtlBidInvoices(bid_id: number): Promise<any> {
        return ftlBidsService.printFtlBidInvoices(bid_id)
    }

    printLogistBid(bid_id: number): Promise<any> {
        return ftlBidsService.printLogistBid(bid_id)
    }

    printFtlBidWaypointInvoice(bid_id: number, waypoint_index: number): Promise<any> {
        return ftlBidsService.printFtlBidWaypointInvoice(bid_id, waypoint_index)
    }

    checkAvr(order_id: number): Promise<{ data: { isPosted: boolean } }> {
        return ftlBidsService.checkAvr(order_id)
    }

    getQuantity(params: FtlIntracityGetQuantityParams): Promise<FtlIntracityGetQuantityResponse> {
        return ftlBidsService.getQuantity(params)
    }

    sendRequestForPayment(id: number, payload: FtlOrderSendRequestForPaymentPayload): Promise<void> {
        return ftlBidsService.sendRequestForPayment(id, payload)
    }
}

export const ftl_bids = new OrdersRealisation()
